(() => {
  class DMCoulissesLoop extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.visible = false;
      this.video.muted = true;
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        this.sync();
      }, options);
      this.video.addEventListener('playing', () => {
        if (!this.shouldPlay()) { this.video.pause(); return; }
        this.video.hidden = false;
        this.paint(true);
      }, options);
      this.video.addEventListener('pause', () => this.paint(false), options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.video.hidden = true;
        this.button.hidden = true;
      }, options);
      this.motion.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.preferences = new MutationObserver(() => this.sync());
      this.preferences.observe(document.documentElement, { attributes: true, attributeFilter: ['data-solar-fixed'] });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
        this.sync();
      }, { threshold: [0, .5] });
      this.observer.observe(this);
      this.sync();
    }
    motionDisabled() {
      return this.motion.matches || document.documentElement.dataset.solarFixed === 'true';
    }
    shouldPlay() {
      return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.failed && !this.motionDisabled();
    }
    paint(playing) {
      this.dataset.state = playing ? 'playing' : 'paused';
      this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
    }
    sync() {
      this.button.hidden = this.motionDisabled() || !!this.failed;
      if (!this.shouldPlay()) {
        this.video.pause();
        this.paint(false);
        if (this.motionDisabled()) this.video.hidden = true;
        return;
      }
      if (!this.video.hasAttribute('src')) {
        this.video.src = this.video.dataset.src;
        this.video.load();
      }
      if (this.starting || !this.video.paused) return;
      this.starting = true;
      let interrupted = false;
      this.video.play().then(() => {
        if (!this.shouldPlay()) this.video.pause();
      }).catch(error => {
        interrupted = error.name === 'AbortError';
        this.paint(false);
      }).finally(() => {
        this.starting = false;
        if (interrupted && this.shouldPlay()) this.sync();
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.preferences?.disconnect();
      this.video?.pause();
      this.ready = false;
    }
  }
  if (!customElements.get('dm-coulisses-loop')) customElements.define('dm-coulisses-loop', DMCoulissesLoop);
})();
